(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const sectionSelector = '.custom-footer-section';

    const getNavAccordions = (section) =>
      section.querySelectorAll('.footer-content > :nth-child(2) > .group-block-content > :not(:first-child) accordion-custom.menu');

    const wireMenuHeadings = (section) => {
      const navGroups = section.querySelectorAll(
        '.footer-content > :nth-child(2) > .group-block-content > :not(:first-child)'
      );

      navGroups.forEach((group) => {
        const headingBlock = group.querySelector('.text-block.h3');
        const details = group.querySelector('accordion-custom.menu details.menu__details');
        const summary = details?.querySelector('.menu__heading');
        const defaultHeading = summary?.querySelector('.menu__heading__default');
        const accordionHeading = summary?.querySelector('.menu__heading__accordion');
        const toggle = accordionHeading?.querySelector('.menu__heading__toggle');

        if (
          !headingBlock ||
          !(details instanceof HTMLDetailsElement) ||
          !(summary instanceof HTMLElement) ||
          !(defaultHeading instanceof HTMLElement) ||
          !(accordionHeading instanceof HTMLElement)
        ) {
          return;
        }

        const headingText = headingBlock.textContent?.trim();
        if (!headingText) return;

        headingBlock.classList.add('custom-footer-mobile-hide-heading');
        summary.classList.remove('menu__heading--empty');

        defaultHeading.textContent = headingText;
        accordionHeading.textContent = headingText;
        if (toggle) accordionHeading.append(toggle);
      });
    };

    const forceClosedMobile = (section) => {
      if (!mobileQuery.matches) return;

      const accordions = getNavAccordions(section);
      accordions.forEach((accordion) => {
        accordion.removeAttribute('open-by-default-on-mobile');
        accordion.setAttribute('data-disable-on-mobile', 'false');

        const details = accordion.querySelector('details.menu__details');
        if (details instanceof HTMLDetailsElement) {
          details.removeAttribute('open');
          details.open = false;
        }
      });
    };

    const bindDelegatedToggle = (section) => {
      if (section.dataset.customFooterToggleDelegated === 'true') return;

      section.dataset.customFooterToggleDelegated = 'true';
      section.addEventListener('click', (event) => {
        if (!mobileQuery.matches) return;

        const summary = event.target instanceof Element ? event.target.closest('summary.menu__heading') : null;
        if (!(summary instanceof HTMLElement)) return;

        const details = summary.closest('details.menu__details');
        if (!(details instanceof HTMLDetailsElement)) return;

        event.preventDefault();
        event.stopPropagation();
        details.open = !details.open;
      });
    };

    const syncFooterMenus = () => {
      const sections = document.querySelectorAll(sectionSelector);

      sections.forEach((section) => {
        wireMenuHeadings(section);
        bindDelegatedToggle(section);
        forceClosedMobile(section);
      });
    };

    syncFooterMenus();
    window.setTimeout(syncFooterMenus, 120);
    window.setTimeout(syncFooterMenus, 350);
    window.setTimeout(syncFooterMenus, 700);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncFooterMenus);
    }

    document.addEventListener('shopify:section:load', syncFooterMenus);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-gallery-main"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
